import { render } from "./quotations.vue?vue&type=template&id=6b878021&scoped=true"
import script from "./quotations.vue?vue&type=script&lang=js"
export * from "./quotations.vue?vue&type=script&lang=js"

import "./quotations.vue?vue&type=style&index=0&id=6b878021&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b878021"]])

export default __exports__